module.exports = __webpack_public_path__ + "img/logo-oncology.e95c54be.png";